import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((_theme: Theme) => ({
  tabWrapper: {
    width: '98%',
    height: '96vh',
    margin: '20px auto',
  },
}));

export default useStyles;
